import { cas_color, tgc_color, SWD_color } from "./SunburstColorMapping"
import * as d3 from "d3";

export const formatSunburstData = (data, type) => {


  let level1Field = "firstLevel";
  let level2Field = "secondLevel";
  let level3Field = "thirdLevel"




  const colorMapping = {
    "TGC": tgc_color,
    "CAS": cas_color,
    "SWD": SWD_color,
  }


  const selectedColor = colorMapping[type];
  // Filter out entries with null values in the specified fields
  const filteredData = data?.filter(entry => entry[level1Field] && entry[level2Field] && entry[level3Field]);

  const sunburstData = {
    name: "root",
    color: "transparent",
    children: []
  };

  // Group data by the specified level1Field
  const level1Groups = d3.group(filteredData, d => d[level1Field]);

  level1Groups.forEach((entries, level1Key) => {
    const level1Node = {
      name: level1Key,
      color: selectedColor({ name: level1Key }),
      children: []
    };

    // Group by level2Field within each level1 group
    const level2Groups = d3.group(entries, d => d[level2Field]);

    level2Groups.forEach((entries2, level2Key) => {
      const level2Node = {
        name: level2Key,
        color: selectedColor({ name: level2Key, parent: { name: level1Key } }),
        children: []
      };

      // Group by level3Field within each level2 group
      const level3Groups = d3.group(entries2, d => d[level3Field]);

      level3Groups.forEach((entries3, level3Key) => {
        const value = entries3.reduce((acc, item) => acc + item.value, 0);
        const level3Node = {
          name: level3Key,
          value: value,
          color: selectedColor({ name: level3Key, parent: { name: level2Key, parent: { name: level1Key } } })
        };
        level2Node.children.push(level3Node);
      });

      level1Node.children.push(level2Node);
    });

    sunburstData.children.push(level1Node);
  });


  return sunburstData;
};



